module.exports = __webpack_public_path__ + "static/media/right_arrow_icon.f39004a4.svg";